import React from "react";
import { HelmetProvider } from 'react-helmet-async';
import { SigilProvider } from "./context/sigilContext";
import { UserProvider } from "./context/UserContext";
import { ThemeProvider } from '@mui/material/styles';
import { themeSigil } from "./Theme";
import { CssBaseline } from "@mui/material";
import Main from "./pages/Main";
import { Analytics } from "@vercel/analytics/react"

function App() {

  return (
    <SigilProvider>
      <UserProvider>
        <HelmetProvider>
          <ThemeProvider theme={themeSigil}>
            <CssBaseline />
            <Main />
            <Analytics />
          </ThemeProvider>
        </HelmetProvider>
      </UserProvider>
    </SigilProvider>
  );
}

export default App;
